import { createApiService } from 'relapp-api';

export default {
    ...createApiService('customer')
};
